<template>
  <error-layout :code="403" error="Нет доступа"></error-layout>
</template>

<script>
import ErrorLayout from '../layouts/ErrorLayout.vue';

export default {
  metaInfo() {
    return {
      title: '403 – Нет доступа',
    };
  },
  components: { ErrorLayout },
};
</script>
